module.exports = __webpack_public_path__ + "img/demo3.47d5e67.png";